<template>
    <div>
        <b-modal
            :id="modalId"
            ref="creditConvertForm"
            title-tag="h2"
            :title="`Convert to Refund, ` + credit.name"
            :lazy="true"
            ok-title="Proceed"
            @ok="proceed()"
            :ok-disabled="isOkDisabled"
            footer-class="d-flex justify-content-between"
        >
            <form name="convert-form">
                <b-form-group label-for="date" label="Date:" label-cols="4">
                    <date-picker
                        :config="datePickerOptions"
                        v-model="currentDate"
                        v-validate="'required'"
                        class="form-control"
                        placeholder="Date (required)"
                        name="date"
                    ></date-picker>
                </b-form-group>
                <b-form-group label-for="type" label="Type:" label-cols="4">
                    <select
                        v-model="refundType"
                        v-validate="'required'"
                        name="repeat"
                        class="form-control"
                        aria-invalid="false"
                    >
                        <option
                            v-for="item in refundTypeOptions"
                            :key="item.id"
                            :value="item.id"
                            :disabled="item.id == -1"
                        >
                            {{ item.name }}</option
                        >
                    </select>
                </b-form-group>

                <b-form-group
                    v-if="isCCTerminal"
                    :label-for="`terminal`"
                    label-cols="4"
                    label="Terminal:"
                >
                    <b-form-select
                        id="terminal"
                        v-model="payment_data.terminal"
                        v-validate="'excluded:0'"
                        :class="{ 'border-danger': errors.has('terminal') }"
                        :disabled="isNoTerminal"
                        name="terminal"
                    >
                        <option
                            v-for="(value, key) in payment_data.terminals"
                            :key="key"
                            :value="key"
                            >{{ value }}</option
                        >
                    </b-form-select>
                </b-form-group>
                <b-form-group label-for="note" label="Notes:" label-cols="4">
                    <b-form-textarea
                        v-model="editNote"
                        placeholder="Notes (optional)"
                        rows="3"
                        name="note"
                    ></b-form-textarea>
                </b-form-group>
            </form>
        </b-modal>
        <modal-refund-approval
            ref="modalRefundApproval"
            @proceed="convertCredit"
        />
    </div>
</template>
<script type="text/javascript">
import Payment from "@/services/payment";
import EXTENSIONS from "@/constants/extensions";
import PaymentDialogHelper from "@/module/payment/helper.js";
import BillingCreditServices from "@/services/billing/billing-credit";

const CHARITABLE_FUND_TYPE = 2;

export default {
    mixins: [PaymentDialogHelper],
    components: {
        ModalRefundApproval: () =>
            import("@/components/billing-credit/modal-refund-approval")
    },
    props: {
        modalId: {
            type: String,
            required: true
        },
        credit: {
            type: Object,
            default() {
                return { id: null };
            }
        }
    },
    computed: {
        isOkDisabled() {
            return this.refundType == -1 || this.currentDate == null;
        },
        isCCTerminal() {
            let cardConnectTerminal = _.find(
                this.refundTypeOptions,
                refundTypeOption => {
                    return this._checkPaymentName(
                        refundTypeOption.name,
                        "terminal",
                        "CardConnect"
                    );
                }
            );

            return (
                cardConnectTerminal && this.refundType == cardConnectTerminal.id
            );
        },
        isNoTerminal() {
            return (
                this.payment_data.terminals &&
                this.payment_data.terminals[0] == "No Terminal"
            );
        }
    },
    data() {
        return {
            currentDate: null,
            editNote: null,
            refundType: null,
            refundTypeOptions: [],
            datePickerOptions: {
                format: "DD/MM/YYYY"
            },
            payment_data: {
                terminals: [],
                terminal: null
            }
        };
    },
    mounted() {
        this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
            if (modalId == this.modalId) {
                this.init();
                this.getPaymentTypeOptions();

                if (this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CCONNECT)) {
                    this._getTerminals(this.payment_data);
                }
            }
        });
    },
    methods: {
        init() {
            this.datePickerOptions.format = this.getDateFormat();
            this.currentDate = this._now().toFormat(this._dateFormat);
            this.editNote = _.clone(this.credit.note);
        },
        proceed() {
            let self = this;

            let params = {
                id: this.credit.id,
                date: this._fromDateStrToDateTime(this.currentDate, true),
                type: this.refundType,
                terminal: this.payment_data.terminal,
                note: this.editNote
            };

            if (!self.isCCTerminal) {
                self.convertCredit(params);
                return;
            }

            params.blindRefund = true;
            this.$refs["modalRefundApproval"].open(params);
        },
        convertCredit(params) {
            BillingCreditServices.convertToRefund(params)
                .then(response => {
                    if (
                        response.code == 200 &&
                        response.messages &&
                        response.messages.message == "Error" &&
                        response.messages.error_message
                    ) {
                        // error no response from terminal
                        this._message(
                            response.messages.error_message,
                            "danger"
                        );
                    } else if (response.code == 200) {
                        this._message(response.messages);
                        this.$emit("reload");
                    } else {
                        this._message(response.messages, "danger");
                    }
                })
                .catch(error => {
                    this._message("Error : Unable to convert credit", "danger");
                    console.error(error);
                })
                .finally(() => {
                    this.$refs["modalRefundApproval"].close();
                });
        },
        getPaymentTypeOptions() {
            let self = this;
            let params = { is_filter_funds: true };
            this.paymentTypeOptions = [];

            if (this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CCONNECT)) {
                params.cc_processor_enabled = 1;
            }

            Payment.getPaymentType(params)
                .then(response => {
                    this.refundTypeOptions = response.resources.payment_types;
                })
                .then(() => {
                    _.remove(this.refundTypeOptions, function (n) {
                        return (
                            self
                                .convertCardConnectName(n.name)
                                .includes("creditcardonfile(cardconnect)") ||
                            self
                                .convertCardConnectName(n.name)
                                .includes("creditcardkeyed-in(cardconnect)") ||
                            n.category_id == CHARITABLE_FUND_TYPE
                        );
                    });

                    self.refundTypeOptions.unshift({
                        id: -1,
                        name: "Please select a refund type (required)"
                    });

                    self.refundType = -1;
                });
        },
        convertCardConnectName(cardConnectName) {
            return cardConnectName.replaceAll(" ", "").toLowerCase();
        }
    }
};
</script>
